import type { LensCardData } from '~/types/leLens';

import source from './emailSource.json';
import { addDays, readSelection, todaySydney, validDate } from './reportModel';

/** The original relative-date filter includes today and the preceding 28 days. */
export function emailScope(params: URLSearchParams, now = new Date()) {
  const requestedRange = params.get('emailRange');
  const range = ['7', '29', '90'].includes(requestedRange ?? '')
    ? requestedRange!
    : params.has('emailFrom') || params.has('emailTo') ? 'custom' : '29';
  const to = range === 'custom' && validDate(params.get('emailTo')) ? params.get('emailTo') : todaySydney(now);
  const from = range === 'custom' && validDate(params.get('emailFrom'))
    ? params.get('emailFrom')
    : addDays(to, -(range === 'custom' ? 28 : Number(range) - 1));
  const selections = Object.fromEntries(
    source.filters.map((filter) => [filter.key, readSelection(params, `email_${filter.key}`, filter.defaultValue)]),
  );
  return { from, to, range, selections };
}

/** Only the complete, settled worksheet may authorize totals, exports, or bridge reads. */
export function emailResultReady(
  cards: Array<LensCardData>,
  state: { valid: boolean; success: boolean; fetching: boolean; previous: boolean; error: boolean },
): boolean {
  const card = cards.find((item) => item.cardId === 'daily_clicks');
  return (
    state.valid &&
    state.success &&
    !state.fetching &&
    !state.previous &&
    !state.error &&
    Boolean(
      card &&
      !card.truncated &&
      // An empty worksheet may come back without a rows array; it is still a complete answer of no clicks.
      (card.status === 'empty' || (card.status === 'ready' && Array.isArray(card.rows))),
    )
  );
}
